import { observer } from 'mobx-react-lite';
import { ticketupload } from '../ticketupload.store';
import styles from '../styles.module.scss';
import Button from '../../../ui/button';
import '../../modalcontainer/bodyContent/roomUpload/sections/uploadImage/styles.scss';

const UploadBody = observer(() => {
  const {
    ticketNumberValue,
    errorMsg,
    onInputTicketNumber,
    sendTicketNumber,
    disabled,
  } = ticketupload;

  return (
    <div className={styles.ticketUpload}>
      <div className={styles.ticketUploadTitleRow}>
        <span className={styles.ticketUploadTitleText}>
          To join the event please submit the 10-digit number that is right
          under the QR code of your ticket!
        </span>
      </div>
      <div className={styles.inputWrp}>
        <p className={styles.inputText}>Ticket number</p>
        <div className="inputCase lg">
          <input
            value={ticketNumberValue}
            onChange={(e) => onInputTicketNumber(e.target.value)}
            className="input"
            type="number"
            placeholder="1234789"
          />
          <div className="inputCaseAction">
            <Button
              type="rounded-15"
              disabled={!ticketNumberValue || !!errorMsg.number || disabled}
              size="circledSmall"
              color="primary"
              onClick={sendTicketNumber}
            >
              <i className="circleButtonIcon icon-right" />
            </Button>
          </div>
        </div>
        <p className={styles.errorText}>{errorMsg.number}</p>
      </div>
    </div>
  );
});

export default UploadBody;
